// ItemIssuePage.jsx
import {Navbar,Footer,Sidebar} from '../medicalcomponents';
import React, { useEffect, useState, useRef  } from "react";
import axios from "axios";
import configData from "../config.json";
import { format } from 'date-fns';
import { useReactToPrint } from "react-to-print";
import Select from "react-select";

// Example props: none required — it fetches itemList from backend
export default function ItemIssueCom() {

    const componentRef = useRef(null);

  const [itemList, setItemList] = useState([]); // {id, name, stockQty}
  const [filterItemList, setFilterItemList] = useState([]);
  const [itemId, setItemId] = useState("");
  const [qty, setQty] = useState("");
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemSearch,setItemSearch]=useState("");
  const [consumer,setConsumer]=useState("");
  const [useOf,setUseOf]=useState("G");
  

  const [empData,setEmpData]=useState([]);
  const [filterEmp, setFilterEmp] = useState([]);
  const [empSearch,setEmpSearch]=useState();
  const [empID, setEmpId] = useState("");
  const [medecineDose, setMedecineDose] = useState("");
  const [medecineDays, setMedecineDays] = useState("");

  const [voucher, setVoucher] = useState([]);
  

  useEffect(() => {
    const getAssetData = async () => {
          const response=await axios.get(configData.SERVER_URL+`/itemData/${localStorage.getItem('branchID')}`);
          setItemList(response.data);
          setFilterItemList(response.data);

          const res=await axios.get(configData.SERVER_URL+`/empData/${localStorage.getItem('branchID')}`);
          setEmpData(res.data);
          setFilterEmp(res.data);

    };
    getAssetData();
  }, []);

  const resetInputs = () => {
    setItemId("");
    setQty("");
    // setRemarks("");
  };

  const handleAddToGrid = () => {
    if (!itemId) return alert("Select an item.");
    if (!qty || Number(qty) <= 0) return alert("Enter valid quantity.");

    const selected = itemList.find((i) => String(i.id) === String(itemId));
    if (!selected) return alert("Invalid item selected.");

    // Add row (simple push, duplicates allowed in this simple version)
    setGridData((prev) => [
      ...prev,
      {
        itemId: selected.id,
        itemName: selected.itemName,
        qty: Number(qty),
        medecineDose: medecineDose,
        medecineDays:medecineDays,
      },
    ]);

    resetInputs();
  };

  const handleDeleteRow = (index) => {
    setGridData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEditRow = (index) => {
    // simple inline edit flow: load row into inputs and remove row
    const row = gridData[index];
    setItemId(row.itemId);
    setQty(row.qty);
    // setRemarks(row.remarks);
    setGridData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmitFinal = async () => {
    if (gridData.length === 0) return alert("No items to submit.");

    const payload = {
      issueDate: format(new Date(),'yyyy-MM-dd'),
      items: gridData,
      empID:empID,
      branchID:localStorage.getItem('branchID'),
      consumer:consumer,
      useOf:useOf,
    };

    try {
        setLoading(true);
        let res=await axios.post(configData.SERVER_URL+`/voucherEntry`,payload);
        if(res.status===200){
            alert(res.data.message);
            setGridData([]);
            setVoucher(res.data.voucher.data);
        }
    } catch (err) {
      console.error(err);
      alert("Save failed: " + (err.message || err));
    } finally {
      setLoading(false);
    }
  };

  const filterItem=(e)=>{

    const value = e.target.value.toLowerCase();   
    setItemSearch(value);

    const updatedList = itemList.filter(items =>
        items.itemCode?.toLowerCase().includes(value) ||
        items.itemName?.toLowerCase().includes(value) ||
        items.groupName?.toLowerCase().includes(value)
    );
    setFilterItemList(updatedList);
    }

    const filterEmployee=(e)=>{
        const value = e.target.value.toLowerCase(); 
        setEmpSearch(value);
        const updatedList = empData.filter(emp =>
        emp.empCode?.toLowerCase().includes(value) ||
        emp.empName?.toLowerCase().includes(value) 
        );
        setFilterEmp(updatedList);
    }

    const printDiv = () => {
        const printContent = document.getElementById("print-area").innerHTML;
        const originalContent = document.body.innerHTML;

        document.body.innerHTML = printContent;
        window.print();
        document.body.innerHTML = originalContent;
        window.location.reload();
    };

  return (
    <>
        <div className="well">
          <div className="card" >

      <div className="card well bg-info ">
        <div className="card-body" style={{padding: "20px", borderRadius: "10px"}}>
            <div className='col-lg-6 col-sm-6 col-xs-12' >
                <div style={{ flex: 2 }}>
                <label>Issue To</label>

                <Select options={filterEmp.map(d => ({ value: d.id, label: d.empCode+':'+d.empName }))} isSearchable 
                  placeholder="Select Employee..."
                  onChange={(selectedOption) => {
                  if (selectedOption) {
                  setEmpId(selectedOption.value);   // store ID
                  } else {
                  setEmpId(null);
                  }
                  }}
                  />

                </div>
            </div>

            <div className='col-lg-6 col-sm-6 col-xs-12'>
                <label>Use of</label>
                <select className="form-control" value={useOf} onChange={(e) => setUseOf(e.target.value)}>
                    <option value="G">General</option>   
                    <option value="E">Emergency</option>
                </select>
            </div>

            <div className='col-lg-6 col-sm-6 col-xs-12'>
                <label>Consumer</label>
                <select className="form-control" value={consumer} onChange={(e) => setConsumer(e.target.value)}>
                    <option value="Self">Self</option>   
                    <option value="Family">Family</option>
                </select>
            </div>
        </div>
      </div>
      
      <div className="card well">
        <div className="card-body bg-light" style={{padding: "20px", borderRadius: "10px"}}>
            <div className='row'>
            <div style={{ display: "flex", gap: 12, alignItems: "flex-end", marginBottom: 12 }}>
                <div style={{ flex: 2 }}>
                <label>Item</label>
                <Select options={filterItemList.map(it => ({ value: it.id, label: (it.itemCode+' : '+it.itemName+' -> '+(Number(it.openingStock) + Number(it.mrr_qty) - Number(it.issueQty))) }))} isSearchable 
                  placeholder="Select Items..."
                  onChange={(selectedOption) => {
                  if (selectedOption) {
                  setItemId(selectedOption.value);   // store ID
                  } else {
                  setItemId(null);
                  }
                  }}
                  />
            </div>
            </div>

            <div className='row'>
            <div style={{ width: 300 }}>
                <label>Medecine Dose</label>
                <input type="text" className="form-control" name="medecineDose" id="medecineDose"   value={medecineDose} onChange={(e)=>setMedecineDose(e.target.value)}></input>
            </div>

            <div style={{ width: 120 }}>
                <label>Days</label>
                <input className="form-control" type="number" min="1" value={medecineDays} onChange={(e) => setMedecineDays(e.target.value)} />
            </div>

            <div style={{ width: 120 }}>
                <label>Qty</label>
                <input className="form-control" type="number" min="1" value={qty} onChange={(e) => setQty(e.target.value)} />
            </div>

            <div style={{textAlign:'right'}}>
                <button className="btn btn-success" onClick={handleAddToGrid} style={{ marginBottom: 4 }}> Add </button>
            </div>
            </div>

            </div>
        </div>
      </div>

      <table class="table table-info table-hover table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Item</th>
            <th>Dose</th>
            <th>Qty</th>
            
            <th style={{ width: 150 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {gridData.length === 0 ? (
            <tr>
              <td colSpan={5} style={{ textAlign: "center" }}>
                No items added
              </td>
            </tr>
          ) : (
            gridData.map((r, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{r.itemName}</td>
                <td>{r.medecineDose+" -> "+r.medecineDays+" days"}</td>
                <td>{r.qty}</td>
   
                <td>
                  <button className="btn btn-sm btn-primary mr-2" onClick={() => handleEditRow(i)}>
                    Edit
                  </button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDeleteRow(i)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div style={{ display: "flex", gap: 12 }}>
        <button className="btn btn-primary" onClick={handleSubmitFinal} disabled={loading}>
          {loading ? "Saving..." : "Submit All"}
        </button>
        <button className="btn btn-secondary" onClick={() => setGridData([])} disabled={loading}>
          Clear Grid
        </button>
      </div>
          </div>
          {
          voucher && voucher.length>0 &&(
        <div className="card" id="print-area" >
            <div className='card-header bg-info text-center'>
                <h2>Pescription Details</h2> 
                <button onClick={printDiv}>Print</button> 
            </div>
            <div className="card-body" style={{padding: "20px", borderRadius: "10px"}}>
                <div class="my-3"><label>Invoice No: {voucher[0].issueNo}</label></div>
                <div class="my-3"><label>Invoice Date: {format(voucher[0].issueDate,'dd-MM-yyyy')}</label></div>
                <div class="my-3"><label>Issue To: {voucher[0].empName+"/"+voucher[0].empCode+" : "+voucher[0].deptName}</label></div>
                <div class="my-3"><label>Consumer: {voucher[0].consumer}</label></div>
            </div>
            <table class="table table-info table-hover table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Item</th>
            <th>Dose</th>
            <th>Days</th>
            <th>Qty</th>
          </tr>
        </thead>
        <tbody>
            {
            voucher.map((r, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{r.itemName+" : "+r.itemCode}</td>
                <td>{r.medecineDose}</td>
                <td>{r.medecineDays}</td>
                <td>{r.issueQty}</td>
              </tr>
            ))
        }
        </tbody>
      </table>

        </div>
          )
          }
        </div>   
    </>
  );
}
